import { render, staticRenderFns } from "./mediaLibrary.vue?vue&type=template&id=84d623f6&scoped=true&"
import script from "./mediaLibrary.vue?vue&type=script&lang=js&"
export * from "./mediaLibrary.vue?vue&type=script&lang=js&"
import style0 from "./mediaLibrary.vue?vue&type=style&index=0&id=84d623f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d623f6",
  null
  
)

export default component.exports